import React from "react";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";

const kpis = [
  {
    label: "Profit uplift Delivered",
    value: 20,
    prefix: "$",
    suffix: "M+",
  },
  {
    label: "Transformations Executed",
    value: 300,
    suffix: "+",
  },
  {
    label: "Average ROI within 30 days",
    value: 8.3,
    suffix: "x",
  },
  {
    label: "Average Satisfaction Score",
    value: 4.8,
    suffix: "★",
  },
];

const KPIs_overview = () => {
  return (
    <div className="py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-full px-4 sm:px-6 lg:px-8">
        <div className="sm:text-center">
          <h2 className="text-center text-xl font-semibold leading-8 text-blue-900">
            Our Key Metrics
          </h2>
          <p className="mt-2 text-center text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Performance at a Glance
          </p>
        </div>
        <div className="mt-10 flex flex-wrap justify-center gap-10">
          {kpis.map((kpi, index) => {
            const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
            return (
              <div
                key={index}
                ref={ref}
                className="w-[310px] flex flex-col items-center justify-center text-center rounded-2xl bg-white px-6 py-8 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="text-4xl font-extrabold text-gray-900">
                  {inView ? (
                    <CountUp
                      start={0}
                      end={kpi.value}
                      duration={2}
                      separator=","
                      decimals={Number.isInteger(kpi.value) ? 0 : 1}
                      prefix={kpi.prefix || ""}
                      suffix={kpi.suffix || ""}
                    />
                  ) : (
                    `${kpi.prefix || ""}0${kpi.suffix || ""}`
                  )}
                </div>
                <div className="mt-2 text-lg font-medium text-gray-600">
                  {kpi.label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default KPIs_overview;
